// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610081501/js/" + chunkId + "." + {"44":"671b3ef4","225":"fc7ccf43","481":"f744e6eb","486":"58b71835","770":"6bfbb6a4"}[chunkId] + ".0.24910220364471947.chunk.js";
};